import "./styles.css";

export interface WeekViewProps {
  selectedDays: string[];
  onDayToggle: (day: string) => void;
  disabled?: boolean;
}

const DAYS_OF_WEEK = [
  { value: "monday", label: "M" },
  { value: "tuesday", label: "T" },
  { value: "wednesday", label: "W" },
  { value: "thursday", label: "T" },
  { value: "friday", label: "F" },
  { value: "saturday", label: "S" },
  { value: "sunday", label: "S" },
];

const WeekView = ({ selectedDays, onDayToggle, disabled = false }: WeekViewProps) => {
  return (
    <div className="week-view">
      {DAYS_OF_WEEK.map((day) => {
        const isSelected = selectedDays.includes(day.value);
        return (
          <button
            key={day.value}
            type="button"
            className={`week-view-day ${isSelected ? "week-view-day--selected" : ""}`}
            onClick={() => !disabled && onDayToggle(day.value)}
            disabled={disabled}
            aria-label={day.value}
            title={day.value.charAt(0).toUpperCase() + day.value.slice(1)}
          >
            {day.label}
          </button>
        );
      })}
    </div>
  );
};

export default WeekView;

